import "./Signs.css";
import { ReactComponent as SignsSVG } from "./images/signs.svg";

function Signs() {
  var firstSignText = document.getElementById("first-sign-text");
  console.log(firstSignText);
  return (
      <div>
        <SignsSVG />
      </div>
  );
}

export default Signs;